// extracted by mini-css-extract-plugin
export default {"group":"ConversationGroup_group__h4nEm","groupTitle":"ConversationGroup_groupTitle__t033T","groupItems":"ConversationGroup_groupItems__uuNUR"};